import { PagePerformedByRequestDTO } from './page-performed-by-request-dto';

export interface ReadContextRequestDTO extends PagePerformedByRequestDTO {
    languageCd?: string;
}
